import {
  AccountBubble,
  RegisterSpecialMenu,
  LogoutSpecialMenu,
} from "./AccountBubble";
import { useUtilities } from "@ten24/slatwall-storefront-react-private/global";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MenuItem = (props) => {
  const { eventHandlerForWSIWYG } = useUtilities();
  const { t } = useTranslation();
  const {
    linkLabel = "",
    linkUrl = "",
    children,
    specialMenuType,
    cssClass,
    childItem,
    showAllLink,
  } = props;

  const [linkSelected, setLinkSelected] = useState(false);
  const rapperRef = useRef();
  useEffect(() => {
    function handleClickOutside(event) {
      if (rapperRef.current && !rapperRef.current.contains(event.target)) {
        setLinkSelected(false);
      }
    }
    if (linkSelected)
      document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rapperRef, linkSelected]);

  return (
    <li
      key={linkLabel}
      className={`nav-item dropdown ${cssClass ? cssClass : ""}`}
    >
      {!children?.length && (
        <>
          {!specialMenuType && (
            <Link
              className={`nav-link p-2 ${cssClass ? cssClass : ""}`}
              to={linkUrl}
            >
              {linkLabel}
            </Link>
          )}
          {specialMenuType === "user-account" && (
            <AccountBubble
              cssClass={cssClass}
            />
          )}
          {specialMenuType === "user-register" && (
            <RegisterSpecialMenu
              cssClass={cssClass}
              linkLabel={linkLabel}
            />
          )}
          {specialMenuType === "user-logout" && (
            <LogoutSpecialMenu
              cssClass={cssClass}
              linkLabel={linkLabel}
            />
          )}
        </>
      )}
      {!!children?.length && (
        <>
          <span
            className={`nav-link dropdown-toggle p-2 d-flex align-items-center ${specialMenuType? specialMenuType : ''} ${
              cssClass ? cssClass : ""
            }`}
            role="button"
            onClick={() => setLinkSelected(!linkSelected)}
          >
            {linkLabel}
          </span>
          <div
            ref={rapperRef}
            className={`mega-menu dropdown-menu border pt-0 ${
              linkSelected && "show"
            } ${childItem ? "w-100 m-0 top-0 bottom-0" : "top-100"}`}
          >
            {childItem && (
              <div className="menu-back-arrow w-100 ps-3 mt-3">
                <i
                  ref={(node) => {
                    node?.style.setProperty("font-size", "1rem", "important");
                    node?.style.setProperty(
                      "-webkit-text-stroke",
                      "1px",
                      "important"
                    );
                  }}
                  className="bi bi-arrow-left"
                  role="button"
                  onClick={() => setLinkSelected(false)}
                ></i>
              </div>
            )}
            {showAllLink?.trim() && (
              <div className="nav-shop-all ">
                <Link to={showAllLink}>
                  {`${t("frontend.nav.shopall")} ${linkLabel}`}
                  <i className="bi bi-arrow-right ms-2"></i>
                </Link>
              </div>
            )}
            <div className="d-flex flex-wrap px-2 my-3">
              <ul className="d-flex flex-wrap px-0">
                {children.map((menuPanel, index) => {
                  menuPanel.props.el.childItem = true;
                  return (
                    <div key={index} className="mega-dropdown-column">
                      <div
                        className="widget widget-links"
                        onClick={eventHandlerForWSIWYG}
                      >
                        {menuPanel}
                      </div>
                    </div>
                  );
                })}
              </ul>
            </div>
          </div>
        </>
      )}
    </li>
  );
};

export { MenuItem };
